import * as Sentry from "@sentry/vue";

export default class SentryTransactionWrapper {
  #mainSpan = undefined;

  start(transactionData) {
    if (this.#mainSpan === undefined) {
      transactionData.forceTransaction = true;

      this.#mainSpan = Sentry.startNewTrace(() => {
        return Sentry.startInactiveSpan(transactionData);
      });
      return true;
    }
    console.error("Transaction already started");
    return false;
  }

  end() {
    if (this.#mainSpan !== undefined) {
      this.#mainSpan.end();
      this.#mainSpan = undefined;
      return true;
    }
    return false;
  }

  makeSpan(spanData, autoFinish = true, parent = undefined) {
    if (this.#mainSpan === undefined) {
      console.error("No transaction, call `start` method first.");
      return undefined;
    }
    parent = parent || this.#mainSpan;

    spanData.parentSpan = parent;

    const span = Sentry.startInactiveSpan(spanData);
    if (autoFinish) {
      span.end();
    }
    return span;
  }
}
